import * as wasm from "./date_parser_bg.wasm";
export * from "./date_parser_bg.js";
import { __wbg_set_wasm } from "./date_parser_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
